<script setup lang="ts">
const props = defineProps<{
	row: any
}>()
</script>

<template>
	<div class="flex items-center gap-2">
		<UBadge
			v-if="row.slug === 'ax_card_status_change' && row.ax_data?.decrypted_result?.status"
			:color="row.ax_data.decrypted_result.status === 'INACTIVE' ? 'red' : row.ax_data.decrypted_result.status === 'ACTIVE' ? 'green' : 'gray'"
			variant="solid"
			:label="row.ax_data.decrypted_result.status"
		/>
		<template v-else>
			<UBadge
				v-if="row.ax_data?.decrypted_result?.transaction?.transType"
				color="gray"
				variant="soft"
				:label="row.ax_data.decrypted_result.transaction.transType"
			/>
			<UBadge
				v-if="row.ax_data?.decrypted_result?.transaction?.transStatus"
				:color="
					row.ax_data.decrypted_result.transaction.transStatus === 'APPROVED' ? 'green' :
					row.ax_data.decrypted_result.transaction.transStatus === 'DECLINED' ? 'red' :
					row.ax_data.decrypted_result.transaction.transStatus === 'PENDING' ? 'yellow' :
					'gray'"
				variant="soft"
				:label="row.ax_data.decrypted_result.transaction.transStatus"
			/>
		</template>
		<UBadge
			v-if="row.slug === 'user_deposit_usdt_trc20' && row.tx"
			:color="row.tx.tx_success ? 'green' : 'red'"
			variant="solid"
			:label="row.tx.tx_success ? 'SUCCESSFUL' : 'FAILED'"
		/>
	</div>
</template>
